import { render, staticRenderFns } from "./UserAnalysis.vue?vue&type=template&id=6a6ed978&scoped=true"
import script from "./UserAnalysis.vue?vue&type=script&lang=js"
export * from "./UserAnalysis.vue?vue&type=script&lang=js"
import style0 from "./UserAnalysis.vue?vue&type=style&index=0&id=6a6ed978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ed978",
  null
  
)

export default component.exports